import type { ProductCard } from "@itaas/pep-contracts";
import { Link } from "react-router-dom";
import { productDisplayName, productTagline } from "../../utils/labels";
import { isPrelaunchProduct } from "../../utils/product-status";
import { BIOMETRIC_MODULE_SLUGS } from "../../utils/biometric-trial";
import {
  buildConfigureHrefForProduct,
  commercialCtaLabelForProduct,
} from "../../utils/commercial-cta";
import { ProductLogo } from "./ProductLogo";

export function IndustryProductCard({
  product,
  industrySlug,
}: {
  product: ProductCard;
  industrySlug?: string;
}) {
  const tagline = productTagline(product, "fr");
  const hasTrial = Boolean(product.trialDays && product.status !== "planned");
  const configureTo = buildConfigureHrefForProduct(product, { industry: industrySlug });

  return (
    <article className="card h-100 border-0 shadow-sm">
      <div className="card-body d-flex flex-column p-3">
        <Link
          to={`/products/${product.slug}`}
          className="text-decoration-none text-body"
        >
          <div className="d-flex align-items-center gap-2 mb-2">
            <ProductLogo slug={product.slug} name={productDisplayName(product, "fr")} size={44} />
            <div className="fw-semibold">{productDisplayName(product, "fr")}</div>
          </div>
          <div className="small text-secondary mb-2">
            {tagline.slice(0, 100)}
            {tagline.length > 100 ? "…" : ""}
          </div>
        </Link>
        {BIOMETRIC_MODULE_SLUGS.has(product.slug) && (
          <p className="small text-secondary mb-2 mb-md-auto">
            {product.slug === "rh"
              ? "1 lecteur biométrique inclus par défaut — quantité augmentable."
              : product.slug === "edu"
                ? "Pointage biométrique : 1 lecteur par défaut, 1 par salle recommandé."
                : "Terminaux ZKTeco — quantité ajustable à la demande."}
          </p>
        )}
        <div className="d-flex flex-wrap gap-2 mt-auto pt-2">
          <Link className="btn btn-sm btn-outline-secondary" to={`/products/${product.slug}`}>
            Détails
          </Link>
          {hasTrial && product.portfolio?.trialAllowed !== false && (
            <Link className="btn btn-sm btn-primary" to={configureTo}>
              {commercialCtaLabelForProduct(product, "fr")}
            </Link>
          )}
          {isPrelaunchProduct(product.status) && (
            <Link className="btn btn-sm btn-outline-primary" to={configureTo}>
              Rejoindre la liste d&apos;attente
            </Link>
          )}
          {!hasTrial &&
            !isPrelaunchProduct(product.status) &&
            product.portfolio?.trialAllowed === false && (
            <Link className="btn btn-sm btn-primary" to={configureTo}>
              {commercialCtaLabelForProduct(product, "fr")}
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}
